enum PediatricDoseInputType {
    WEIGHT = 'WEIGHT',
    AGE = 'AGE'
}

export default PediatricDoseInputType;
